import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { purify } from "@vfit/shared/themes";
import { Button, ImageAtoms } from "@vfit/shared/atoms";
import * as S from "./errorGenericV2.style";
export var ErrorGenericV2 = function(param) {
    var title = param.title, subtitle = param.subtitle, description = param.description, descriptionOnTop = param.descriptionOnTop, action = param.action, actionText = param.actionText, customAction = param.customAction, customActionText = param.customActionText, icon = param.icon, _variant = param.variant, variant = _variant === void 0 ? "sunrise" : _variant, hideTitle = param.hideTitle;
    var ref = useState(false), disabled = ref[0], setDisabled = ref[1];
    var handleAction = useCallback(function() {
        setDisabled(true);
        action === null || action === void 0 ? void 0 : action();
    }, [
        action
    ]);
    var handleCustomAction = useCallback(function() {
        setDisabled(true);
        customAction === null || customAction === void 0 ? void 0 : customAction();
    }, [
        customAction
    ]);
    var ref1 = _sliced_to_array(purify([
        description,
        subtitle,
        title
    ]), 3), pDescription = ref1[0], pSubtitle = ref1[1], pTitle = ref1[2];
    return /*#__PURE__*/ _jsx(S.Container, {
        children: /*#__PURE__*/ _jsxs(S.MessageDiv, {
            children: [
                !hideTitle && pTitle && /*#__PURE__*/ _jsx(S.Title, {
                    variant: variant,
                    dangerouslySetInnerHTML: {
                        __html: pTitle
                    }
                }),
                icon && /*#__PURE__*/ _jsx(S.ImageContainer, {
                    children: /*#__PURE__*/ _jsx(S.ImageWrapper, {
                        children: /*#__PURE__*/ _jsx(ImageAtoms, {
                            image: icon,
                            nameCard: "iconError",
                            style: {
                                objectFit: "contain"
                            }
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs(S.BodyWrap, {
                    descriptionOnTop: descriptionOnTop,
                    variant: variant,
                    children: [
                        pSubtitle && /*#__PURE__*/ _jsx(S.Subtitle, {
                            variant: variant,
                            dangerouslySetInnerHTML: {
                                __html: pSubtitle
                            }
                        }),
                        pDescription && /*#__PURE__*/ _jsx(S.Description, {
                            variant: variant,
                            dangerouslySetInnerHTML: {
                                __html: pDescription
                            }
                        })
                    ]
                }),
                (actionText || customActionText) && /*#__PURE__*/ _jsxs(S.InsideButtonContainer, {
                    variant: variant,
                    children: [
                        actionText && /*#__PURE__*/ _jsx(Button, {
                            variant: variant === "mva" ? "mva:primary" : "primary",
                            onClick: handleAction,
                            disabled: disabled,
                            children: actionText
                        }),
                        customActionText && /*#__PURE__*/ _jsx(Button, {
                            variant: variant === "mva" ? "mva:alt1" : "tertiary",
                            onClick: handleCustomAction,
                            disabled: disabled,
                            children: customActionText
                        })
                    ]
                })
            ]
        })
    });
};
